import { withStyles } from '@material-ui/core/styles';
import MUISlider from '@material-ui/core/Slider';

function Slider({ color = 'secondary', ...props }) {
  return <MUISlider color={color} {...props} />;
}

export default withStyles({
  root: {
    display: 'block',
    height: 2,
    width: 'auto',
    margin: '0 6px',
    padding: '13px 0',
    '@media (pointer: coarse)': {
      margin: '0 10px',
      padding: '20px 0',
    },
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -5,
    marginLeft: -6,
    '@media (pointer: coarse)': {
      height: 24,
      width: 24,
      marginTop: -11,
      marginLeft: -11,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 2,
  },
  rail: {
    color: '#f2f2f2',
    opacity: 1,
    height: 2,
  },
})(Slider);
